import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  InsertTaskManagerSectionDocument,
  type InsertTaskManagerSectionMutationVariables,
} from '@/graphql/generated/graphql';

export type TaskManagerSectionInsertInput = InsertTaskManagerSectionMutationVariables;

export const useInsertTaskManagerSection = () => {
  const mutation = useMutation({
    mutationKey: ['insert-task-manager-section'],
    mutationFn: (variables: InsertTaskManagerSectionMutationVariables) =>
      graphqlClient.request(InsertTaskManagerSectionDocument, variables),
  });

  return {
    ...mutation,
    insertTaskManagerSection: mutation.mutate,
    insertTaskManagerSectionAsync: mutation.mutateAsync,
  };
};

export const INSERT_TASK_MANAGER_SECTION_MUTATION = InsertTaskManagerSectionDocument;
